import { UNSUBSCRIBE } from "../strings/myAccount";
import { STATEMENTS as STATEMENTS_STRINGS } from "../strings/myAccount";

export const ACC_LANDING_CARD_KEY_MAP = {
  TRADING_BALANCE: "tradingBalance",
  EQUITY_PLANS: "equityPlans",
  INVESTMENT_ESSENTIALS: "investmentEssentials",
  MORE_OPTIONS: "moreOptions"
};

export const TAX_STATUS_MAP = {
  "01": "Individual",
  "02": "On Behalf Of Minor",
  "03": "HUF",
  "04": "Company",
  "05": "AOP",
  "06": "Partnership Firm",
  "08": "Trust",
  "10": "Others",
  "12": "DFI",
  "21": "NRE",
  "23": "FII",
  "24": "NRO",
  "35": "Government Body",
  "40": "Local Authority",
  "47": "LLP",
};

export const BANK_ACC_TYPE_MAP = {
  'SB': "Savings",
  'CA': "Current Account",
  'CC': "Cash Credit",
  'SB-NRE': "Savings Bank NRE",
  'SB-NRO': "Savings Bank NRO",
  'other': "Other"
};

export const MANDATE_STATUS_COLOR_MAP = {
  "approved": "secondary.profitGreen.400",
  "in_progress": "secondary.mango.400",
  "pending_on_user": "secondary.coralOrange.400",
  "rejected": "secondary.lossRed.400"
};

export const FREEDOM_PLAN_STATUS_MAP = {
  STANDARD: {
    title: "Standard plan",
    subtitle: "Brokerage plan",
    subtitleColor: "foundationColors.content.tertiary",
    buttonText: "Upgrade now"
  },
  INIT: {
    title: "Freedom plan",
    subtitle: "Purchase in progress",
    subtitleColor: "foundationColors.secondary.coralOrange[400]",
    buttonText: ""
  },
  ACTIVE: {
    title: "Freedom plan",
    subtitle: (daysLeft) => `Expiring in ${daysLeft} days`,
    subtitleColor: "foundationColors.content.tertiary",
  },
  RENEWAL: {
    title: "Freedom plan",
    subtitle: (daysLeft) => `Expires in ${daysLeft} days`,
    subtitleColor: "foundationColors.secondary.coralOrange[400]",
    buttonText: "Renew now"
  }
};

export const SETTINGS_OPTIONS_KEY_MAP = {
  SECURITY: "security",
  ORDER_PREFERENCES: "orderPreferences",
  CHART_PREFERENCES: "chartPreferences", // Keep hidden until wave insourcing is completed
  WHATSAPP_NOTIFS:"whatsappNotif",
  EMAIL_SUBSCRIPTION:"emailSubscriptioN",
  LOGOUT: "logout"
};

export const STATEMENT_CATEGORY_OPTIONS_KEY_MAP = {
  CAPITAL_GAIN_MF: "capital_gains_mf",
  CAPITAL_GAIN_STOCKS: "capital_gains",
  CONTRACT_NOTE: "contract_note",
  PROFIT_AND_LOSS: "profit_loss",
  STOCKS_TRX: "transaction",
  LEDGER: "ledger",
  DEMAT_HOLDINGS: "demat_holding",
  ELSS: "elss",
  MF_PORTFOLIO: "portfolio_mf",
  MF_TRX: "transaction_mf",
};

export const STATEMENT_CATEGORY_KEY_MAP = {
  TAX_FILING: "taxFiling",
  STOCKS: "stocks",
  MF: "mutualFunds"
};

export const STATEMENT_CATEGORIES_LIST = [
  /*
    NOTE: all items below are ordered in the screen/view as per the order here.
    Changing the order here will directly affect the order of elements in the
    screen/view.
  */
  {
    key: STATEMENT_CATEGORY_KEY_MAP.TAX_FILING,
    categoryTitle: STATEMENTS_STRINGS.TAX_FILING.sectionTitle.text,
    componentDataAid: STATEMENTS_STRINGS.TAX_FILING.componentDataAid,
    categoryOptions: [{
      key: STATEMENT_CATEGORY_OPTIONS_KEY_MAP.ELSS,
      title: STATEMENTS_STRINGS.TAX_FILING.elss.title.text,
      titleDataAid: STATEMENTS_STRINGS.TAX_FILING.elss.title.dataAid,
      // rowDataAid: STATEMENTS_STRINGS.TAX_FILING.elss.rowDataAid
    }, {
      key: STATEMENT_CATEGORY_OPTIONS_KEY_MAP.CAPITAL_GAIN_MF,
      title: STATEMENTS_STRINGS.TAX_FILING.mutualFund.title.text,
      titleDataAid: STATEMENTS_STRINGS.TAX_FILING.mutualFund.title.dataAid,
      // rowDataAid: STATEMENTS_STRINGS.TAX_FILING.mutualFund.rowDataAid
    }, {
      key: STATEMENT_CATEGORY_OPTIONS_KEY_MAP.CAPITAL_GAIN_STOCKS,
      title: STATEMENTS_STRINGS.TAX_FILING.stocks.title.text,
      titleDataAid: STATEMENTS_STRINGS.TAX_FILING.stocks.title.dataAid,
      // rowDataAid: STATEMENTS_STRINGS.TAX_FILING.stocks.rowDataAid
    }]
  }, {
    key: STATEMENT_CATEGORY_KEY_MAP.STOCKS,
    categoryTitle: STATEMENTS_STRINGS.STOCKS_AND_OPTIONS.sectionTitle.text,
    componentDataAid: STATEMENTS_STRINGS.STOCKS_AND_OPTIONS.componentDataAid,
    categoryOptions: [{
      key: STATEMENT_CATEGORY_OPTIONS_KEY_MAP.CONTRACT_NOTE,
      title: STATEMENTS_STRINGS.STOCKS_AND_OPTIONS.contractNote.title.text,
      titleDataAid: STATEMENTS_STRINGS.STOCKS_AND_OPTIONS.contractNote.title.dataAid,
      // rowDataAid: STATEMENTS_STRINGS.STOCKS_AND_OPTIONS.contractNote.rowDataAid
    }, {
      key: STATEMENT_CATEGORY_OPTIONS_KEY_MAP.PROFIT_AND_LOSS,
      title: STATEMENTS_STRINGS.STOCKS_AND_OPTIONS.profitAndLoss.title.text,
      titleDataAid: STATEMENTS_STRINGS.STOCKS_AND_OPTIONS.profitAndLoss.title.dataAid,
      // rowDataAid: STATEMENTS_STRINGS.STOCKS_AND_OPTIONS.profitAndLoss.rowDataAid
    }, {
      key: STATEMENT_CATEGORY_OPTIONS_KEY_MAP.STOCKS_TRX,
      title: STATEMENTS_STRINGS.STOCKS_AND_OPTIONS.transaction.title.text,
      titleDataAid: STATEMENTS_STRINGS.STOCKS_AND_OPTIONS.transaction.title.dataAid,
      // rowDataAid: STATEMENTS_STRINGS.STOCKS_AND_OPTIONS.transaction.rowDataAid
    }, {
      key: STATEMENT_CATEGORY_OPTIONS_KEY_MAP.LEDGER,
      title: STATEMENTS_STRINGS.STOCKS_AND_OPTIONS.ledger.title.text,
      titleDataAid: STATEMENTS_STRINGS.STOCKS_AND_OPTIONS.ledger.title.dataAid,
      // rowDataAid: STATEMENTS_STRINGS.STOCKS_AND_OPTIONS.ledger.rowDataAid
    }, {
      key: STATEMENT_CATEGORY_OPTIONS_KEY_MAP.DEMAT_HOLDINGS,
      title: STATEMENTS_STRINGS.STOCKS_AND_OPTIONS.dematHolding.title.text,
      titleDataAid: STATEMENTS_STRINGS.STOCKS_AND_OPTIONS.dematHolding.title.dataAid,
      // rowDataAid: STATEMENTS_STRINGS.STOCKS_AND_OPTIONS.dematHolding.rowDataAid
    }]
  }, {
    key: STATEMENT_CATEGORY_KEY_MAP.MF,
    categoryTitle: STATEMENTS_STRINGS.MUTUAL_FUND.sectionTitle.text,
    componentDataAid: STATEMENTS_STRINGS.MUTUAL_FUND.componentDataAid,
    categoryOptions: [{
      key: STATEMENT_CATEGORY_OPTIONS_KEY_MAP.MF_PORTFOLIO,
      title: STATEMENTS_STRINGS.MUTUAL_FUND.portfolio.title.text,
      titleDataAid: STATEMENTS_STRINGS.MUTUAL_FUND.portfolio.title.dataAid,
      // rowDataAid: STATEMENTS_STRINGS.MUTUAL_FUND.portfolio.rowDataAid
    }, {
      key: STATEMENT_CATEGORY_OPTIONS_KEY_MAP.MF_TRX,
      title: STATEMENTS_STRINGS.MUTUAL_FUND.transaction.title.text,
      titleDataAid: STATEMENTS_STRINGS.MUTUAL_FUND.transaction.title.dataAid,
      rightIconName: "ivn_email.svg",
      rightIconDataAid: STATEMENTS_STRINGS.MUTUAL_FUND.transaction.rightIconDataAid
      // rowDataAid: STATEMENTS_STRINGS.MUTUAL_FUND.transaction.rowDataAid
    }]
  }
];

export const OP_EXCHANGE_API_KEY_MAP = {
  NSE_CASH: "nse_cash",
  BSE_CASH: "bse_cash",
  NSE_DERIVATIVES: "nse_derivatives",
  NSE_CDS: "nse_cds",
  NSE_OTS: "nse_ots"
};

export const ORDER_TYPE_MAP = {
  DELIVERY: "delivery",
  INTRADAY: "intraday",
  CARRYFORWARD: "carryforward"
};

export const PROTECTION_LIMIT_CONSTANTS = {
  MIN_VALUE: 0,
  MAX_VALUE: 99,
  STEP_VALUE: 1,
  MAX_BREACH_ERROR_MSG: `Maximum protection % is ${99}%`,
  MIN_BREACH_ERROR_MSG: `Protection value cannot be below ${0}`
};

export const INV_ACC_PRODUCTS_KEY_MAP = {
  STOCKS: "stocks",
  MF: "mf",
  FNO: "fno",
  CURRENCY: "currency"
};

export const KYC_STATUS_KEY_MAP = {
  INIT: 'init',
  IN_PROGRESS: 'inprogress',
  COMPLETE: 'complete',
  REJECTED: 'rejected',
  INACTIVE: 'inactive'
};

export const INV_ACC_KYC_STATUS_PROPS_MAP = {
  [KYC_STATUS_KEY_MAP.INIT]: {
    actionBtnText: "Activate"
  },
  [KYC_STATUS_KEY_MAP.IN_PROGRESS]: {
    statusTagProps: {
      label: "In progress",
      textColor: "foundationColors.secondary.coralOrange.400",
      backgroundColor: "foundationColors.secondary.coralOrange.200"
    }
  },
  [KYC_STATUS_KEY_MAP.COMPLETE]: {
    // Do nothing
  },
  [KYC_STATUS_KEY_MAP.INACTIVE]: {
    // Do nothing
  },
  [KYC_STATUS_KEY_MAP.REJECTED]: {
    actionBtnText: "Retry",
    statusTagProps: {
      label: "Rejected",
      textColor: "foundationColors.secondary.lossRed.400",
      backgroundColor: "foundationColors.secondary.lossRed.200"
    }
  },
};

export const EMAIL_SUBSCRIPTION_OPTIONS = [
  {
    title: UNSUBSCRIBE.CONTENT.newsLetterContentRow.title.text,
    subtitle: UNSUBSCRIBE.CONTENT.newsLetterContentRow.subtitle.text,
    rowDataAid: UNSUBSCRIBE.CONTENT.newsLetterContentRow.rowDataAid,
    apiKey: "research_newsletter",
  },
  {
    title: UNSUBSCRIBE.CONTENT.productReleaseRow.title.text,
    subtitle: UNSUBSCRIBE.CONTENT.productReleaseRow.subtitle.text,
    rowDataAid: UNSUBSCRIBE.CONTENT.productReleaseRow.rowDataAid,
    apiKey: "clevertap",
  },
  {
    title: UNSUBSCRIBE.CONTENT.marketingEmailRow.title.text,
    subtitle: UNSUBSCRIBE.CONTENT.marketingEmailRow.subtitle.text,
    rowDataAid: UNSUBSCRIBE.CONTENT.marketingEmailRow.rowDataAid,
    apiKey: "marketing",
  },
];